<template>
    <div>
        <el-dialog :visible.sync="outWarehouseDialog" width="50%" top="13vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog" :show-close = false>
                <el-form ref="form" :model="request" label-position="center">
                    <el-form-item label="选择文件" required>
                    <el-upload class="upload" ref="upload" accept=".xlsx, .xls" action="#" :http-request="uploadHttpRequest" :file-list="fileList" :limit="limitNum" :auto-upload="false" :on-change="handleChange"
                               :on-exceed="onExceed" :on-remove="onRemove" style="float:left;">
                        <el-button size="small" type="warning" plain  style="width:200px">excel导入</el-button>
                    </el-upload>
                    <div style="float:left;margin-left: 5px">
                        
                        <span v-if="response.deviceIds > 0">设备数量：{{response.deviceIds}}</span>
                    </div>
                </el-form-item>
                </el-form>
            <el-table :data="response.data" style="margin:auto;width:calc(100% - 30px)" height="500" border :row-style="{ height: '0.5%' }" 
                :cell-style="{ padding: '0.5%' }" :header-cell-style="{background:'#01DFD7',color:'#fff'}" highlight-current-row
                @current-change="handleCurrentChange">
                <el-table-column label="申请ID" align="center" width="200" prop="applyId"></el-table-column>
                <el-table-column label="代理名称" align="center" width="200" prop="sourceCsUserName"></el-table-column>
                <el-table-column label="代理电话" align="center" width="200" prop="sourceCsUserPhone"></el-table-column>
                <el-table-column label="设备类型" align="center" width="200" prop="deviceType"></el-table-column>
                <el-table-column label="申请数量" align="center" width="200" prop="num"></el-table-column>
                <el-table-column label="发货仓库" align="center" width="200" prop="warehouseName"></el-table-column>
                <el-table-column label="申请时间" align="center" width="200" prop="createTime"></el-table-column>
                <el-table-column label="申请状态" align="center" width="200" prop="stateStr"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="warning" plain @click="submitUpload">上传</el-button>
                <el-button style="background-color:#A9F5F2;margin: 0" @click="outWarehouseDialog = false">取消</el-button>
                <el-button style="background-color:#A9F5A9" @click="outWarehouse">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getAllApply, excelUpload, outWarehouse} from "../../../api/warehousedevice/warehousedevice.js";
import { formatDate } from "../../../utils/date.js";
export default {
    data() {
        return {
            outWarehouseDialog: false,
            loading: false,
            request: {
                applyId: '',
                csId: '',
                csUserId: '',
                csName: '',
                csPhone: '',
                applyNum: '',
                warehouse: '',
                deviceIds: []
            },
            response: {data: [], deviceIds: 0},
            fileList: [],
            limitNum: 1,
            
            
        }
    },
    methods: {
        init(){
            this.outWarehouseDialog = true;
            getAllApply().then(result=>{
                this.response.data = result.data;
            })
        },

        /**
         * excel上传
         */
        uploadHttpRequest() {
            if (this.fileList.length === 0) {
                this.$confirm('文件不能为空', '错误', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error',
                    center: true
                })
                return;
            } else {
                const file = new FormData();
                this.fileList.forEach(item=>{
                    file.append("excelFile", item.raw);
                })
                excelUpload(file).then(result=>{
                    if(result.code === '000000'){
                        this.response.deviceIds = result.data.length;
                        this.request.deviceIds = result.data;
                        this.loading = false;
                    }else{
                        this.$message.error(result.message);
                        this.loading = false;
                    }
                    
                })
            }
        },

        /**
         * 提交上传
         */
        submitUpload(){
            this.$refs.upload.submit();
        },

        /**
         * 文件改变钩子
         */
        handleChange(file, fileList){
            this.fileList = fileList;
        },

        /**
         * 文件超出个数时钩子
         */
        onExceed(file,fileList){
            this.$message.error("已选择文件！");
        },

        /**
         * 文件移除钩子
         */
        onRemove(file,fileList){
            this.$refs.upload.clearFiles();
            this.response.deviceIds = 0;
            this.request.deviceIds = [];
        },

        /**
         * 出库
         */
        outWarehouse(){
            outWarehouse(this.request).then(result=>{
                if(result.code === '000000'){
                    this.$emit("in-succeed","出库成功");
                    this.$message({
                        message: "出库成功",
                        type: "success",
                        duration: 1500,
                    });
                }
            });
            this.outWarehouseDialog = false;
        },

        /**
         * 选择列表
         */
        handleCurrentChange(item){
            this.request.applyId = item.applyId;
            this.request.csId = item.sourceCsId;
            this.request.csUserId = item.sourceCsUserId;
            this.request.csName = item.sourceCsUserName;
            this.request.csPhone = item.sourceCsUserPhone;
            this.request.applyNum = item.num;
            this.request.warehouse = item.targetWarehouseId;
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.request.applyId = '';
            this.request.csId = '';
            this.request.csUserId = '';
            this.request.csName = '';
            this.request.csPhone = '';
            this.request.applyNum = '';
            this.request.warehouse = '';
            this.request.deviceIds = [];
            this.onRemove();
        }
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/warehouse/warehousedevice/outwarehouse.vue